<div class="hotelLocation" *ngIf="locations" [ngStyle]="locations.shopping.size == 0 && locations.healthCenters.size == 0
    && locations.transportation.size == 0 && locations.culture.size == 0 && locations.landmarks.size == 0 
    && locations.emergencyStations.size == 0
    && locations.nearby.size ==0?{'display':'none'}:{}">
    <h5 class="hotel-heading">Points of Interest</h5>
    <div class="location">
        <div class="hotelLocationColumn" *ngIf="locations.shopping.size > 0">
            <h3 class="location__heading">Shopping and Dining</h3>
            <div class="hotelLocationInner">
                <div class="location__item" *ngFor="let location of getKeys(locations.shopping)">
                    <p>{{location}}</p>
                    <div class="flex">
                        <div *ngFor="let place of locations.shopping.get(location)">
                            {{place}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="hotelLocationColumn" *ngIf="locations.healthCenters.size > 0">
            <h3 class="location__heading">Health centers</h3>
            <div class="hotelLocationInner">
                <div class="location__item" *ngFor="let location of getKeys(locations.healthCenters)">
                    <p>{{location}}</p>
                    <div class="flex">
                        <div *ngFor="let place of locations.healthCenters.get(location)">
                            {{place}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="hotelLocationColumn" *ngIf="locations.transportation.size > 0">
            <h3 class="location__heading">Transportation</h3>
            <div class="hotelLocationInner">
                <div class="location__item" *ngFor="let location of getKeys(locations.transportation)">
                    <p>{{location}}</p>
                    <div class="flex">
                        <div *ngFor="let place of locations.transportation.get(location)">
                            {{place}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="hotelLocationColumn" *ngIf="locations.culture.size > 0">
            <h3 class="location__heading">Culture</h3>
            <div class="hotelLocationInner">
                <div class="location__item" *ngFor="let location of getKeys(locations.culture)">
                    <p>{{location}}</p>
                    <div class="flex">
                        <div *ngFor="let place of locations.culture.get(location)">
                            {{place}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="hotelLocationColumn" *ngIf="locations.landmarks.size > 0">
            <h3 class="location__heading">Landmarks</h3>
            <div class="hotelLocationInner">
                <div class="location__item" *ngFor="let location of getKeys(locations.landmarks)">
                    <p>{{location}}</p>
                    <div class="flex">
                        <div *ngFor="let place of locations.landmarks.get(location)">
                            {{place}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="hotelLocationColumn" *ngIf="locations.emergencyStations.size > 0">
            <h3 class="location__heading">Emergency stations</h3>
            <div class="hotelLocationInner">
                <div class="location__item" *ngFor="let location of getKeys(locations.emergencyStations)">
                    <p>{{location}}</p>
                    <div class="flex">
                        <div *ngFor="let place of locations.emergencyStations.get(location)">
                            {{place}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="hotelLocationColumn" *ngIf="locations.nearby.size > 0">
            <h3 class="location__heading">Near By</h3>
            <div class="hotelLocationInner">
                <div class="location__item" *ngFor="let location of getKeys(locations.nearby)">
                    <p>{{location}}</p>
                    <div class="flex">
                        <div *ngFor="let place of locations.nearby.get(location)">
                            {{place}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>